import { put, select, takeLatest, call } from "redux-saga/effects";
import { handleAuthResponse, loginWatcher } from "../actions/loginactioncreators";
import { handleError } from "../actions/loginactioncreators";
import getIsPreAuth from "../helpers/getIsPreAuth";
import getPassword from "../helpers/getPassword";
import getChallenge from "../helpers/getChallenge";
// import getSaveDevice from "../helpers/getSaveDevice";// TODO COR-1814
import actiontypes from "../actions/actiontypes";
import { CognitoClient } from "../../lib/cognitoClient";

export function* verifyOtpCode(action) {
    try {
        // TODO COR-1814
        // const saveDevice = yield select(getSaveDevice);
        const isPreAuth = yield select(getIsPreAuth);
        if (isPreAuth) {
            const cognitoResponse = yield call(CognitoClient.confirmOtp, action.payload);
            yield put(handleAuthResponse(cognitoResponse));
        } else {
            const challenge = yield select(getChallenge);
            const password = yield select(getPassword);
            const otpPayload = {
                flowStage: "CHALLENGE_MFA_SETUP",
                challengeResponse: {
                    session: challenge.session,
                    challengeName: challenge.challengeName,
                    step: action.payload.step,
                    challengeParameters: {
                        USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
                        MFA_CONFIG: {
                            VERIFICATION_CODE: action.payload.code
                        },
                        PASSWORD: password
                    }
                }
            };

            yield put(loginWatcher(otpPayload));
        }

        // if (saveDevice) {
        //   // TODO COR-1814 implement device key first
        //   // REQUIRES VALID DEVICE KEY TO HAVE BEEN SET ELSEWHERE
        //   yield cognitoUser.setDeviceStatusRemembered({
        //     onSuccess: function(result) { },
        //     onFailure: function(rememberDeviceFailure) {
        //       // TODO decide what to do here
        //     },
        //   });
        // }
    } catch (error) {
        yield put(handleError(error));
    }
}


export function* watchMfaOtpCodeAsync() {
    yield takeLatest([actiontypes.MFA_VERIFY_SMS_CODE, actiontypes.MFA_VERIFY_EMAIL_CODE], verifyOtpCode);
}